import React from 'react';
import CountUp from 'react-countup';
import '../../styles/dashboard/StatsCard.css';

function StatsCard({
  title,
  value,
  subtitle,
  decimals = 0,
  color,
  iconImg,
  suffix = ""
}) {
  return (
    <div className="stats-card" style={{ '--card-color': color }}>
      
      {iconImg && (
        <div className="stats-card-icon">
          <img src={iconImg} alt={title} style={{ width: 32, height: 32 }} />
        </div>
      )}

      <div className="stats-card-value" style={{ color: color }}>
        <CountUp
          end={value}
          duration={1.5}
          separator={decimals === 0 ? "," : ""}
          decimals={decimals}
          decimal="."
          preserveValue={true}
        />
        {suffix}
      </div>

      <div className="stats-card-subtitle">
        {title}<br/>{subtitle}
      </div>

    </div>
  );
}

export default StatsCard;